var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3108_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1489_",
    style: {
      fill: "#E0D5CE"
    },
    d: "M290,0h-60H80C63.431,0,50,13.431,50,30v400c0,16.569,13.431,30,30,30h150h150 c16.569,0,30-13.431,30-30V120L290,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1491_",
    style: {
      fill: "#EADDD3"
    },
    d: "M230,460H80c-16.569,0-30-13.431-30-30V30C50,13.431,63.431,0,80,0h150V460z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1494_",
    style: {
      fill: "#BAAFAA"
    },
    d: "M410,120v30l-90-30v-20h70L410,120z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1499_",
    style: {
      fill: "#B8D0D1"
    },
    d: "M290,90V0l120,120h-90C303.431,120,290,106.569,290,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1758_",
    style: {
      fill: "#C6BAB3"
    },
    d: "M355,249.365H105c-2.761,0-5-2.239-5-5v-9.063c0-2.761,2.239-5,5-5h250 c2.761,0,5,2.239,5,5v9.063C360,247.126,357.761,249.365,355,249.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2613_",
    style: {
      fill: "#C6BAB3"
    },
    d: "M355,320H105c-2.761,0-5-2.239-5-5v-10c0-2.761,2.239-5,5-5h250 c2.761,0,5,2.239,5,5v10C360,317.761,357.761,320,355,320z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2638_",
    style: {
      fill: "#C6BAB3"
    },
    d: "M295,390H165c-2.761,0-5-2.239-5-5v-10c0-2.761,2.239-5,5-5h130 c2.761,0,5,2.239,5,5v10C300,387.761,297.761,390,295,390z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2639_",
    style: {
      fill: "#C6524A"
    },
    d: "M210,115c0,8.284-6.716,15-15,15h-15v15c0,8.284-6.716,15-15,15s-15-6.716-15-15 v-15h-15c-8.284,0-15-6.716-15-15s6.716-15,15-15h15V85c0-8.284,6.716-15,15-15s15,6.716,15,15v15h15 C203.284,100,210,106.716,210,115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2641_",
    style: {
      fill: "#D3625F"
    },
    d: "M150,130.23V130h-15c-8.284,0-15-6.716-15-15s6.716-15,15-15h15V85 c0-8.284,6.716-15,15-15s15,6.716,15,15v15h0.23L150,130.23z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.e9bbb01d.svg";
export { ForwardRef as ReactComponent };